import Plugin from '../core/plugin';
export default class SelfContainedPlugin extends Plugin {
    init(view, appState, dispatch) {
        if (appState.isSelfContained) {
            view.classList.add('self-contained');
        }
    }
    update(view, appState, dispatch) {
        if (appState.isSelfContained !== appState.prev.isSelfContained) {
            if (appState.isSelfContained) {
                view.classList.add('self-contained');
            }
            else {
                view.classList.remove('self-contained');
            }
        }
    }
    unmount(view, appState, dispatch) {
        if (view.className.includes('self-contained')) {
            view.classList.remove('self-contained');
        }
    }
}
